var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"multi-line-button primary--text py-2 px-2",on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }